// Wire values shared by warehouse receipt pages. Keep aligned with backend enums.
export const OrderStatus = Object.freeze({
  CREATED: "CREATED",
  WAIT_DECLARE: "WAIT_DECLARE",
  DECLARED: "DECLARED",
  RELEASED: "RELEASED",
  INBOUND_FINISHED: "INBOUND_FINISHED",
  CANCELED: "CANCELED"
});

export const WmsStatus = Object.freeze({
  INIT: "INIT",
  WMS_CREATE_SUCCESS: "WMS_CREATE_SUCCESS",
  WMS_CREATE_EXCEPTION: "WMS_CREATE_EXCEPTION",
  WMS_STOCKIN_FINISHED: "WMS_STOCKIN_FINISHED",
  STOCKOUT_FINISHED: "STOCKOUT_FINISHED",
  WMS_SEND_UNKNOWN: "WMS_SEND_UNKNOWN",
  WMS_CANCEL_UNKNOWN: "WMS_CANCEL_UNKNOWN",
  WMS_CANCEL_FAILED: "WMS_CANCEL_FAILED",
  WMS_CANCEL_CONFIRMED: "WMS_CANCEL_CONFIRMED"
});

export const OperationType = Object.freeze({
  LOCK: "LOCK",
  UNLOCK: "UNLOCK",
  TRANSFER: "TRANSFER"
});

export const OperationStatus = Object.freeze({
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  REJECTED: "REJECTED"
});

export const UnlockType = Object.freeze({
  PLEDGE_UNLOCK: "PLEDGE_UNLOCK",
  OWNERSHIP_TRANSFER_UNLOCK: "OWNERSHIP_TRANSFER_UNLOCK"
});

export const TransferProgress = Object.freeze({
  WAIT_WMS: "WAIT_WMS",
  SINGLE_SIDE: "SINGLE_SIDE",
  QUANTITY_MISMATCH: "QUANTITY_MISMATCH",
  LOCAL_PENDING: "LOCAL_PENDING",
  CONFIRMED: "CONFIRMED",
  INVALID_DOCUMENTS: "INVALID_DOCUMENTS"
});

export const AuthorizationStatus = Object.freeze({
  SUCCESS: "SUCCESS",
  RETRYABLE: "RETRYABLE",
  RESTART_REQUIRED: "RESTART_REQUIRED"
});

export const AccountBookChangeType = Object.freeze({
  INBOUND_RELEASE: "INBOUND_RELEASE",
  OUTBOUND_FREEZE: "OUTBOUND_FREEZE",
  OUTBOUND_RELEASE: "OUTBOUND_RELEASE",
  OUTBOUND_CANCEL: "OUTBOUND_CANCEL",
  RWA_TRANSFER_IN: "RWA_TRANSFER_IN",
  RWA_TRANSFER_OUT: "RWA_TRANSFER_OUT"
});

export const ExpiryChangeType = Object.freeze({
  INBOUND_RECEIPT: "INBOUND_RECEIPT",
  OUTBOUND_OCCUPY: "OUTBOUND_OCCUPY",
  OUTBOUND_RELEASE: "OUTBOUND_RELEASE",
  OUTBOUND_STOCKOUT: "OUTBOUND_STOCKOUT",
  OUTBOUND_FINISH_RELEASE: "OUTBOUND_FINISH_RELEASE",
  RWA_LOCK_APPLY: "RWA_LOCK_APPLY",
  RWA_LOCK_CONFIRM: "RWA_LOCK_CONFIRM",
  RWA_LOCK_REJECT: "RWA_LOCK_REJECT",
  RWA_PLEDGE_UNLOCK_CONFIRM: "RWA_PLEDGE_UNLOCK_CONFIRM",
  RWA_TRANSFER_APPROVE: "RWA_TRANSFER_APPROVE",
  RWA_TRANSFER_INBOUND: "RWA_TRANSFER_INBOUND",
  RWA_TRANSFER_UNLOCK_CONFIRM: "RWA_TRANSFER_UNLOCK_CONFIRM"
});

export const MergeStatus = Object.freeze({
  NONE: "NONE",
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED"
});

export const mergeStatuses = Object.freeze({
  [MergeStatus.NONE]: "无需归并",
  [MergeStatus.PENDING]: "待归并",
  [MergeStatus.CONFIRMED]: "归并已确认"
});
